<div class="container pt-3">
  <h4 class="primaryFontColor">Überschrift der Teilnehmerliste</h4>
  <input type="text" class="form-control mb-3" [(ngModel)]="titel"
         (keyup.enter)="confirm()" autofocus>
  <button class="btn scButton float-right ml-3 mb-3" (click)="dismiss()">Abbrechen</button>
  <button class="btn pcButton float-right mb-3" (click)="confirm()">Erstellen</button>
</div>
